import styled from 'styled-components';
import { Alert } from '@cashfree-intl/coherent';

export const StyledAlert = styled(Alert)`
  display: flex;
  align-items: center;

  & div {
    flex: 1;
  }

  & button {
    flex-shrink: 0;
    height: 2.5rem;
  }
  & span {
    font-family: 'dm-sans-semi-bold';
  }
`;
